export default __webpack_public_path__ + "static/pay-project-d0148763cece7db16a8eafdf638e1759.png";